function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
import { Chart } from ".";
import { Motivators } from "../Motivators";
import { trackChart } from "../../util";
export var MotivatorChart = /*#__PURE__*/ function(Chart) {
    "use strict";
    _inherits(MotivatorChart, Chart);
    function MotivatorChart(theme) {
        var useMotivatorColors = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, extensions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], eventCallbacks = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
        _class_call_check(this, MotivatorChart);
        var _this;
        _this = _call_super(this, MotivatorChart, [
            theme,
            {
                extensions: extensions
            },
            eventCallbacks
        ]), _define_property(_this, "_shouldUseMotivatorColors", void 0);
        _this._shouldUseMotivatorColors = useMotivatorColors;
        return _this;
    }
    _create_class(MotivatorChart, [
        {
            /**
   * Returns Motivator's level or associated theme color.
   * If instance has been specified not to use Motivator theme colors, then default gradients will be used.
   */ key: "motivatorColor",
            value: function motivatorColor(motivatorID, motivatorPercentage) {
                if (!motivatorID) return null;
                if (this._shouldUseMotivatorColors) return this._motivatorColor(motivatorID);
                if (motivatorPercentage <= 30) return this.theme._palette.graphics.motivatorLevels.neutral;
                if (motivatorPercentage <= 70) return this.theme._palette.graphics.motivatorLevels.niceToHave;
                return this.theme._palette.graphics.motivatorLevels.needToHave;
            }
        },
        {
            key: "_motivatorColor",
            value: function _motivatorColor(motivatorID) {
                return Motivators[motivatorID].color;
            }
        }
    ]);
    return MotivatorChart;
}(Chart);
MotivatorChart = _ts_decorate([
    trackChart
], MotivatorChart);

//# sourceMappingURL=MotivatorChart.js.map